<template>
    <div>
        <div  v-if="currentUser" id="fb-root"></div>
        <b-modal no-fade size="l" id="modal-sharelink" ok-only title="Share this link to your profile and inventory" ok-title="OK">
            https://kegseeker.com/#/brewers/{{userProfile.shortName}} 
        </b-modal>

        <b-navbar  toggleable="lg" type="dark"  style="background-color:#2e5189">
    <b-navbar-brand ><router-link to="brewerdashboard"><img  width="250px" src="../assets/KegSeeker_logo-horizontal-WHITE.png"/></router-link></b-navbar-brand>

    <b-navbar-toggle target="nav-collapse" v-if="currentUser"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav v-if="currentUser">

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto navheader" v-if="currentUser" >
          

        <b-nav-item  v-if="!currentUser"><router-link to="/createaccount" class="navheader2" ><font-awesome-icon icon="user-plus" />  Join Kegseeker</router-link></b-nav-item>  
        <b-nav-item  v-if="!currentUser"><router-link to="/login" class="navheader2" ><font-awesome-icon icon="user" /> Login</router-link></b-nav-item> 

        <b-nav-item v-if="currentUser"><router-link to="/brewerdashboard" class="navheader2" ><font-awesome-icon icon="home" /> Dashboard</router-link></b-nav-item>
        
        <b-nav-item v-if="currentUser"><router-link to="/messagesholder" class="navheader2" ><font-awesome-icon icon="comment" /> Messages <b-badge  variant="light" v-if='unreadCount'>{{unreadCount}}</b-badge></router-link></b-nav-item>
        <b-nav-item v-if="currentUser"><router-link to="/brewerorders" class="navheader2" ><font-awesome-icon icon="list-ul" /> Orders <b-badge variant="light" v-if='newBreweryOrdersCount'>{{newBreweryOrdersCount}}</b-badge></router-link></b-nav-item>
        <b-nav-item v-if="currentUser&&allowConsumers"><router-link to="/receivables" class="navheader2" ><font-awesome-icon icon="dollar-sign" /> Receivables</router-link></b-nav-item>
        <b-nav-item v-if="currentUser"><router-link to="/brewerinvoices" class="navheader2" ><font-awesome-icon icon="dollar-sign" /> Invoices</router-link></b-nav-item>
        <b-nav-item v-if="currentUser&&(userProfile.isbrewer==1||userProfile.isbrewer==10)"><router-link to="inventory" class="navheader2" ><font-awesome-icon icon="warehouse" /> Inventory</router-link></b-nav-item>
        <b-nav-item v-if="currentUser&&userProfile.isbrewer==2"><router-link to="distributorinventory" class="navheader2" ><font-awesome-icon icon="warehouse" /> Inventory</router-link></b-nav-item>
        <b-nav-item-dropdown  v-if="currentUser" right>
          <!-- Using 'button-content' slot -->
          <template v-slot:button-content>
            <font-awesome-icon icon="user" />
          </template>
          <b-dropdown-item  tag="router-link" :to="{ path: '/salesreport' }"><font-awesome-icon icon="chart-line" /> Sales Report</b-dropdown-item>
          <b-dropdown-item   tag="router-link" :to="{ path: '/settings' }"><font-awesome-icon icon="cog" /> Settings</b-dropdown-item>
          <b-dropdown-item @click="showModalForLink" ><font-awesome-icon icon="share" /> Share A Link To Your Inventory</b-dropdown-item>
          
          
          <b-dropdown-item  v-if="currentUser" v-b-tooltip.hover title="Share Your Inventory on you Facebook timeline">
            <social-sharing :url="'https://kegseeker.com/#/brewers/' +userProfile.shortName"
                            title="Check out our inventory on Kegseeker.com"
                            description="See and order our latest beers on Kegseeker.com"
                            quote="Check out our inventory on Kegseeker.com"
                            inline-template>
                <div>

                    <network network="facebook"   >
                        <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook' }"/> Share on Facebook
                    </network>
                </div>
                </social-sharing>
            </b-dropdown-item>
            <!--
          <b-dropdown-item   tag="router-link" :to="{ path: '/brewerevents' }"><font-awesome-icon icon="calendar" /> Events</b-dropdown-item>
          -->
          
          <b-dropdown-item @click="logout" ><font-awesome-icon icon="sign-out-alt" /> Sign Out</b-dropdown-item>
          <b-dropdown-item   tag="router-link" :to="{ path: '/contact' }"><font-awesome-icon icon="question" /> Help</b-dropdown-item>
        </b-nav-item-dropdown>

      </b-navbar-nav>
    </b-collapse>
  </b-navbar>


    </div>
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../firebaseConfig.js')
    export default {
        computed: {
            ...mapState(['userProfile', 'cartCount', 'unreadCount', 'newBreweryOrdersCount', 'currentUser', 'allowConsumers']),
        },
        methods: {
            logout() {
                fb.auth.signOut().then(() => {
                    this.$store.dispatch('clearData')
                    this.$router.push('/login')
                }).catch(err => {
                    console.log(err)
                })
            },
            showModalForLink(){
                this.$bvModal.show("modal-sharelink")
            }
        },
        mounted(){
        }
    }
</script>
<style scoped>

</style>
